import React, { useEffect, useState } from 'react'
import {Routes, Route} from 'react-router-dom'
import Navigation from './components/Navigation'
import Dashboard from './Dashboard'
import Homepage from './Homepage'
import Jobs from './Jobs'
import Testimonals from './Testimonals'
import Faqs from './Faqs'
import Login from './Login'
import './style.css'
import axios from 'axios'
import EmployerZone from './EmployerZone'

function Admin(){
  const [isAuth, setIsAuth] = useState(false)

  useEffect(() => {
    const isAuthenticated = async () => {
      const { data } = await axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      setIsAuth(data.success)
    }
    isAuthenticated()
  })
  console.log("IS Auth: ", isAuth)
  return(
    <div className="admin__wrap">

      {isAuth && <Navigation/>}
      <Routes>
        <Route index element={<Dashboard/>} />
        <Route exact path="/signin" element={<Login isAuth={isAuth} setIsAuth={setIsAuth}/>} />
        <Route exact path="/homepage" element={<Homepage/>} />
        <Route exact path="/jobs" element={<Jobs/>} />
        <Route exact path="/testimonals"  element={<Testimonals/>} />
        <Route exact path="/faqs" element={<Faqs/>} />
        <Route exact path="/employerzone" element={<EmployerZone/>} />
      </Routes>
    </div>
  )
}

export default Admin
